import { Button, Stack, Typography } from "@mui/material"
import { useForm } from "react-hook-form"
import { LassoFormField } from "../../components/form/LassoFormField";
import StepperDUC from "./StepperDUC";
import { useEffect, useState } from "react";

interface FormValues {
    statement: string
}

const Statement = (props: any) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>({
        defaultValues: {
            statement: props?.DUCInfo?.statement || props?.prevData?.data?.statement || ""
        },
    });

    const [wordCount, setWordCount] = useState(0)

    //this useEffect is in case the user either goes back to this component
    //or they are editing we need to insure the word count is set correctly
    useEffect(() => {
        if(props.DUCInfo?.statement){
            const wordCount = props.DUCInfo?.statement.trim().split(/\s+/).length
            setWordCount(wordCount)
        }
        else if(props.prevData?.data?.statement){
            const wordCount = props.prevData?.data?.statement.trim().split(/\s+/).length
            setWordCount(wordCount)
        }
    }, [props.DUCInfo, props.data]);

    const handleClick = (newData: FormValues) => {
        //this setFromStatement is needed in the authorized official step
        //it is needed to set default values or not for the fields in that step
        props.setFromStatement(true)
        props.setDUCInfo({ ...props.DUCInfo, ...newData })
        props.setCurStep(props.curStep + 1)
    }

    const handleClickBack = () => {
        props.setCurStep(props.curStep - 1)
    }

    const handleChange = (e: any, field: any) => {
        if(e.target.value === ""){
            const wordCount = 0
            setWordCount(wordCount)
        }
        else{
            const wordCount = e.target.value.trim().split(/\s+/).length;
            setWordCount(wordCount)
        }
        field.onChange(e)
    }

    const validateWordCount = (value: string) => {
        const wordCount = value.trim().split(/\s+/).length;
        return wordCount <= 250 || "The Statement cannot exceed 250 words";
    };

    return (
        <>
            <Stack gap={3}>
                <Stack flexDirection="column" gap={4}>
                    <StepperDUC
                        activeStep={props.curStep}
                        stepLabels={props.stepLabels} />
                </Stack>

                <Typography variant="h2" fontSize="20px" fontWeight="600">
                        Research Data Use Statement
                </Typography>

                {props.DUCInfo?.ducType === "AIAN" &&
                <Typography>
                    Describe the purpose of the scientific investigation, scholarship or teaching, or other form of 
                    research and research development for which you are requesting access to data from NIH Brain Development Cohorts. 
                    Include detailed information about study aims pertaining to use of data from AI/AN participants, including plans for mitigating 
                    risk of harm to individuals and communities.
                </Typography>}

                {props.DUCInfo?.ducType === "GENERAL" &&
                <Typography>
                    Describe the research objectives of the scientific investigation, scholarship or teaching,
                    or other form of research and research development for which you are requesting access
                    to data from NIH Brain Development Cohorts. Include reference to study design and analysis plan.
                    Indicate that the proposed research is not for commercial use.
                </Typography>}


                <Stack flexDirection="column">
                    <Typography variant="caption">
                        Please note the research data statement cannot exceed 250 words
                    </Typography>
                    <LassoFormField
                        id="duc-statement-data-statement"
                        controller={{
                            name: "statement",
                            control: control,
                            rules: { required: "Research Data Use Statement is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" },
                                maxLength: { value: 5000, message: "The statement cannot exceed 5000 characters" },
                                validate: validateWordCount }
                        }}
                        fullWidth
                        required
                        multiline
                        minRows={12}
                        sx={{
                            '& .MuiInputBase-root textarea': {
                                maxHeight: '60vh',
                                overflow: 'auto'
                            }
                        }}
                        onChange={handleChange}
                        error={'statement' in errors}
                        helperText={errors?.statement?.message || ""}
                    />

                    <Typography
                        sx={{ textAlign: "right" }}>
                    Current word count: <span id="duc-statement-wordcount">{wordCount}</span>
                    </Typography>
                </Stack>

                <Stack
                    flexDirection="row"
                    justifyContent="space-between">

                    <Button
                        id="duc-flow-back-button"
                        variant="tertiary"
                        onClick={handleClickBack}
                        sx={{ alignSelf: "center" }}
                    >
                        Back
                    </Button>  

                    <Button
                        id="duc-flow-continue-button"
                        variant="primary"
                        onClick={handleSubmit(handleClick)}
                        sx={{ alignSelf: "center", marginTop: 3 }}
                    >
                        Continue
                    </Button>
              
                </Stack>

            </Stack>
        </>
    )
}

export default Statement;